var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.3333C21 17.7754 20.8276 18.1993 20.5207 18.5118C20.2138 18.8244 19.7976 19 19.3636 19H4.63636C4.20237 19 3.78616 18.8244 3.47928 18.5118C3.1724 18.1993 3 17.7754 3 17.3333V8.16667C3 7.72464 3.1724 7.30072 3.47928 6.98816C3.78616 6.67559 4.20237 6.5 4.63636 6.5H7.63878C7.80745 6.5 7.96476 6.41496 8.05713 6.27383L9.39742 4.22617C9.48979 4.08504 9.64709 4 9.81577 4H14.1842C14.3529 4 14.5102 4.08504 14.6026 4.22617L15.9429 6.27383C16.0352 6.41496 16.1925 6.5 16.3612 6.5H19.3636C19.7976 6.5 20.2138 6.67559 20.5207 6.98816C20.8276 7.30072 21 7.72464 21 8.16667V17.3333Z",
    fill: "#0A0400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z",
    fill: "#0A0400",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFill);
export default __webpack_public_path__ + "static/media/camera-fill.1ae10e71170c7885f4adf6b6c34258e0.svg";
export { ForwardRef as ReactComponent };